
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/bank-transfers/idempotency-and-retries",
      function () {
        return require("private-next-pages/docs/bank-transfers/idempotency-and-retries.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/bank-transfers/idempotency-and-retries"])
      });
    }
  